// Tile.tsx
import React, { ReactNode } from "react";
import { Box, Card, Typography } from "@mui/material";

interface TileProps {
  title: string;
  value: string | number;
  icon: ReactNode;
  highlight?: boolean;
}

export const Tile = ({ title, value, icon, highlight = false }: TileProps) => (
  <Card
    elevation={highlight ? 6 : 2}
    sx={{
      p: 2,
      backgroundColor: highlight ? "#fff3e0" : "#f9f9f9",
      textAlign: "center",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    }}
  >
    <Box mb={1} display="flex" justifyContent="center">
      {icon}
    </Box>
    <Typography
      variant="caption"
      sx={{
        color: highlight ? "error.main" : "text.secondary",
        fontWeight: "bold",
      }}
    >
      {title}
    </Typography>
    <Typography
      variant="body1"
      sx={{
        fontWeight: "bold",
        mt: 1,
      }}
    >
      {value}
    </Typography>
  </Card>
);
